import TYPES from '@/modules/shared/types';

// Domain
import { CustomerDocumentWealthRepository } from '../../domain/repositories/customer-document-wealth-repository';
import { CustomerDocumentWealthDto } from '../../domain/dtos/customer-document-wealth-dto';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class CustomerDocumentWealthHttpRepository implements
  CustomerDocumentWealthRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private readonly endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/onboarding/customer-document/wealth/`;

  update_bank_statement(customer_document_dto: CustomerDocumentWealthDto): Promise<void> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(`${this.endpoint}bank-statement/`, 'PUT', customer_document_dto)
        .then((response) => {
          if (response.ok) {
            resolve();
          } else {
            response.json()
              .then(({ message }) => {
                reject(new Error(message));
              });
          }
        })
        .catch(reject);
    });
  }

  update_proof_of_address(customer_document_dto: CustomerDocumentWealthDto): Promise<void> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(`${this.endpoint}proof-of-address/`, 'PUT', customer_document_dto)
        .then((response) => {
          if (response.ok) {
            resolve();
          } else {
            response.json()
              .then(({ message }) => {
                reject(new Error(message));
              });
          }
        })
        .catch(reject);
    });
  }
}
